module.exports = __webpack_public_path__ + "static/media/print-on-demand.ac29cdf9.jpg";